import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicWhyHostInfoBlock && values.dynamicWhyHostInfoBlock.length > 0) {
    const dynamicWhyHostInfoBlockErrors = [];
    values.dynamicWhyHostInfoBlock.forEach((item, index) => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item.easyHostTitle1) {
        itemErrors.easyHostTitle1 = messages.required;
      } else if (item.easyHostTitle1.trim() == "") {
        itemErrors.easyHostTitle1 = messages.required;
      } else if (item.easyHostTitle1 && item?.easyHostTitle1?.length > inputTextLimit) {
        itemErrors.easyHostTitle1 = messages.inputTextLimitError;
      }

      if (!item.easyHostContent1) {
        itemErrors.easyHostContent1 = messages.required;
      } else if (item.easyHostContent1.trim() == "") {
        itemErrors.easyHostContent1 = messages.required;
      } else if (item.easyHostContent1 && item?.easyHostContent1?.length > inputDescLimit) {
        itemErrors.easyHostContent1 = messages.inputDescLimitError;
      }

      if (!item.easyHostContent2) {
        itemErrors.easyHostContent2 = messages.required;
      } else if (item.easyHostContent2.trim() == "") {
        itemErrors.easyHostContent2 = messages.required;
      } else if (item.easyHostContent2 && item?.easyHostContent2?.length > inputDescLimit) {
        itemErrors.easyHostContent2 = messages.inputDescLimitError;
      }

      if (!item.workTitle1) {
        itemErrors.workTitle1 = messages.required;
      } else if (item.workTitle1.trim() == "") {
        itemErrors.workTitle1 = messages.required;
      } else if (item.workTitle1 && item?.workTitle1?.length > inputTextLimit) {
        itemErrors.workTitle1 = messages.inputTextLimitError;
      }

      if (!item.workTitle2) {
        itemErrors.workTitle2 = messages.required;
      } else if (item.workTitle2.trim() == "") {
        itemErrors.workTitle2 = messages.required;
      } else if (item.workTitle2 && item?.workTitle2?.length > inputTextLimit) {
        itemErrors.workTitle2 = messages.inputTextLimitError;
      }

      if (!item.workContent1) {
        itemErrors.workContent1 = messages.required;
      } else if (item.workContent1.trim() == "") {
        itemErrors.workContent1 = messages.required;
      } else if (item.workContent1 && item?.workContent1?.length > inputDescLimit) {
        itemErrors.workContent1 = messages.inputDescLimitError;
      }

      if (!item.workContent2) {
        itemErrors.workContent2 = messages.required;
      } else if (item.workContent2.trim() == "") {
        itemErrors.workContent2 = messages.required;
      } else if (item.workContent2 && item?.workContent2?.length > inputDescLimit) {
        itemErrors.workContent2 = messages.inputDescLimitError;
      }

      if (Object.keys(itemErrors).length > 0) {
        dynamicWhyHostInfoBlockErrors[index] = itemErrors;
      }
    });

    if (dynamicWhyHostInfoBlockErrors.length > 0) {
      errors.dynamicWhyHostInfoBlock = dynamicWhyHostInfoBlockErrors;
    }
  }

  return errors
}

export default validate;